import { render } from "./realVideo.vue?vue&type=template&id=ccf12f44&scoped=true"
import script from "./realVideo.vue?vue&type=script&lang=js"
export * from "./realVideo.vue?vue&type=script&lang=js"

import "./realVideo.vue?vue&type=style&index=0&id=ccf12f44&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf12f44"]])

export default __exports__